import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import SecurityReducer from 'core/Security/reducer'

import STORE_NAMESPACES from './namespaces'

const createRootReducer = history =>
  combineReducers({
    [STORE_NAMESPACES.ROUTER]: connectRouter(history),
    [STORE_NAMESPACES.SECURITY]: SecurityReducer,
  })

export default createRootReducer
